import {
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  inject,
} from '@angular/core';
import { VideoPlayerComponent } from '../video-player/video-player.component';
import { RouterLink } from '@angular/router';
import { SessionStorageService } from '../../services/session-storage.service';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-course',
  templateUrl: './course.component.html',
  styleUrl: './course.component.scss',
  imports: [
    VideoPlayerComponent,
    MatIconModule,
    MatButtonModule,
    RouterLink,
    CommonModule,
  ],
})
export class CourseComponent implements OnInit, OnDestroy, OnChanges {
  private ss = inject(SessionStorageService);

  @Input() videoCode: string;
  @Input() app: string;
  @Input() settings: any;

  loadedCourseContent: any;
  unsubscribe = new Subject();
  showVideo = true;

  ngOnInit(): void {
    if (this.ss.get('currentApp') !== 'training')
      this.ss.set('currentApp', 'training');
    this.showVideo = this.checkShowVideo();

    if (this.showVideo) {
      this.loadVideoContent();
    }
  }

  ngOnChanges(): void {
    this.loadVideoContent();
  }

  loadVideoContent(): void {
    this.settings.content.forEach(contentItem => {
      if (contentItem.app === this.app) {
        this.loadedCourseContent = contentItem.curriculum.find(
          curriculumItem => curriculumItem.videoCode === this.videoCode
        );
        this.showVideo = this.checkShowVideo();
      }
    });
  }

  ngOnDestroy() {
    this.unsubscribe.next(null);
    this.unsubscribe.complete();
  }

  checkShowVideo(): boolean {
    return this.loadedCourseContent?.linksList ? false : true;
  }
}
